import styled from "styled-components";
import React from "react";
import { useLocation } from "react-router-dom";

interface PageContainerProps {
  isOnlyContent?: boolean;
  isHomePage?: boolean;
}

const StyledPageContainer = styled.main<PageContainerProps>`
  width: 100%;
  max-width: 100%;
  padding: ${props => {
    if (props.isOnlyContent) return '24px 160px 48px 160px';
    if (props.isHomePage) return '0px 160px 0px 160px';
    return '40px 160px 72px 160px';
  }};
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  position: relative;
  box-sizing: border-box;

  @media (max-width: 960px) {
    padding: ${props => {
      if (props.isOnlyContent) return '20px 40px 36px 40px';
      if (props.isHomePage) return '0px 40px 0px 40px';
      return '32px 40px 36px 40px';
    }};
    gap: ${props => props.isHomePage ? '0' : '48px'};
  }

  @media (max-width: 768px) {
    padding: ${props => {
      if (props.isOnlyContent) return '16px 20px 24px 20px';
      if (props.isHomePage) return '0px 20px 0px 20px';
      return '24px 20px 36px 20px';
    }};
    gap: ${props => props.isHomePage ? '0' : '32px'};
  }
`;

export const PageContainer: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const isOnlyContent = searchParams.has('onlyContent');
  const isHomePage = location.pathname === '/';

  return (
    <StyledPageContainer isOnlyContent={isOnlyContent} isHomePage={isHomePage}>
      {children}
    </StyledPageContainer>
  );
};
